import { all } from 'redux-saga/effects';

import loginWatcher from './login';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function* rootSaga() {
  yield all([loginWatcher()]);
}
